import { AddSectorValues } from 'modules/sector/types/sector';

export const SECTOR_FILTER_KEY = 'sector';

export const addSectorInitValues: AddSectorValues = {
  name: '',
};
